import { mediaQuery, getMediaQuery } from '@jspartials/general-utils';

const mediaQueryTablet = getMediaQuery(mediaQuery.tablet); //min-width: 768px

export default class Manager {
  constructor(desktopMenu, mobileMenu) {
    this.desktopMenu = desktopMenu;
    this.mobileMenu = mobileMenu;
    this.activeMenu = mediaQueryTablet.matches ? desktopMenu : mobileMenu;
  }

  setActiveMenu(menu) {
    if (this.activeMenu === menu) return;
    if (this.activeMenu) this.activeMenu.close();
    this.activeMenu = menu;
  }

  getActiveMenu() {
    return this.activeMenu;
  }

  isDesktopMenuActive() {
    return this.activeMenu === this.desktopMenu;
  }

  isMobileMenuActive() {
    return this.activeMenu === this.mobileMenu;
  }
}
